import { render, staticRenderFns } from "./WFieldRadio.vue?vue&type=template&id=763abd74&"
import script from "./WFieldRadio.vue?vue&type=script&lang=ts&"
export * from "./WFieldRadio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports